export const TRANSACTIONS_FORMS = [
    'cash-transaction-form',
    'tax-transaction-form',
    'income-transaction-form',
    'interest-transaction-form',
    'fee-transaction-form'
];

export const FORM_ROUTE_MAP = {
    EQUITY: ['equity', 'add-transaction', 'equity'],
    RIGHT: ['equity', 'add-transaction', 'right'],
    FUND: ['equity', 'add-transaction', 'fund'],
    ETF: ['equity', 'add-transaction', 'etf'],
    CERT: ['equity', 'add-transaction', 'cert'],
    BOND: ['equity', 'add-transaction', 'bond'],
    SECURITY_TRANSFER: ['transfer', 'add-transaction'],
    fx: ['fx', 'add-transaction'],
    TRANSFER: ['sb-grid', 'cash-transaction-form'],
    CONVERTIBLE: ['sb-grid', 'convertible-form'],
    TAX: ['sb-grid', 'tax-transaction-form'],
    CASH_DIVIDEND: ['sb-grid', 'cash-dividend-transaction-form'],
    ASSET_DIVIDEND: ['sb-grid', 'asset-dividend-transaction-form'],
    SPIN_OFF: ['sb-grid', 'spin-off-transaction-form'],
    RIGHT_ISSUE: ['subscription-right', 'add-transaction', 'subscription-right', 'issue'],
    RIGHT_CONVERSION: [
        'subscription-right',
        '/add-transaction',
        'subscription-right',
        'convert-to-right'
    ],
    EQUITY_CONVERSION: [
        'subscription-right',
        'add-transaction',
        'subscription-right',
        'convert-to-equity'
    ],
    CASH_CONVERSION: [
        'subscription-right',
        'add-transaction',
        'subscription-right',
        'convert-to-cash'
    ],
    INCOME: ['sb-grid', 'income-transaction-form'],
    INTEREST: ['sb-grid', 'interest-transaction-form'],
    FEE: ['sb-grid', 'fee-transaction-form'],
    CASH_LOAN: ['sb-grid', 'cash-loan-form'],
    ACQUISITION_PRICE_ADJUSTMENT: [
        'sb-grid',
        'acquisition-price-adjustment-transaction-form'
    ]
};

// Support only exists for allowing to amend fee, transfer, tax, interest and income
export const INITIATING_TRANSFERS = [
    // 'BUY',
    // 'SELL',
    // 'ENTER_AGREEMENT',
    // 'EXIT_AGREEMENT',
    'FEE',
    'TRANSFER',
    'TAX',
    'SECURITY_TRANSFER',
    //'INTEREST',
    'INCOME'
    //  'DIVIDEND'
];

export const SUBCATEGORY_MAP = {
    DOMESTIC_PENALTY: {
        value: 'DOMESTIC_PENALTY',
        label: 'Domestic penalty tax'
    },
    DOMESTIC_VAT: {
        value: 'DOMESTIC_VAT',
        label: 'Domestic VAT'
    },
    DOMESTIC: {
        value: 'DOMESTIC',
        label: 'Domestic tax'
    },
    DOMESTIC_CORRECTION: {
        value: 'DOMESTIC_CORRECTION',
        label: 'Domestic tax correction'
    },
    FOREIGN_VAT: {
        value: 'FOREIGN_VAT',
        label: 'Foreign VAT'
    },
    FOREIGN_PENALTY: {
        value: 'FOREIGN_PENALTY',
        label: 'Foreign penalty tax'
    },
    FOREIGN: {
        value: 'FOREIGN',
        label: 'Foreign tax'
    },
    FOREIGN_CORRECTION: {
        value: 'FOREIGN_CORRECTION',
        label: 'Foreign tax correction'
    },
    AMORTIZATION: {
        value: 'AMORTIZATION',
        label: 'Amortization'
    },
    BALANCE: {
        value: 'BALANCE',
        label: 'Balance'
    },
    EXTERNAL: {
        value: 'EXTERNAL',
        label: 'External transfer'
    },
    INITIAL_BALANCE: {
        value: 'INITIAL_BALANCE',
        label: 'Initial balance'
    },
    INTERNAL: {
        value: 'INTERNAL',
        label: 'Internal transfer'
    },
    TRANSFER_CORRECTION: {
        value: 'CORRECTION',
        label: 'Transfer correction'
    },
    INCOME_CORRECTION: {
        value: 'CORRECTION',
        label: 'Income correction'
    },
    INTEREST_INCOME: {
        value: 'INTEREST_INCOME',
        label: 'Interest Income'
    },
    KICKBACK: {
        value: 'KICKBACK',
        label: 'Kickback'
    },
    LEASING: {
        value: 'LEASING',
        label: 'Leasing'
    },
    OTHER_REVENUE: {
        value: 'OTHER_REVENUE',
        label: 'Other Revenue'
    },
    RETROCESSION: {
        value: 'RETROCESSION',
        label: 'Retrocession'
    },
    ACCOUNTING_FEE: {
        value: 'ACCOUNTING_FEE',
        label: 'Accounting Fee'
    },
    APARTMENT_RENTAL_FEE: {
        value: 'APARTMENT_RENTAL_FEE',
        label: 'Apartment Rental Fee'
    },
    BANK_FEE: {
        value: 'BANK_FEE',
        label: 'Bank Fee'
    },
    BERTHING_FEE: {
        value: 'BERTHING_FEE',
        label: 'Berthing Fee'
    },
    COMMISSION_FEE: {
        value: 'COMMISSION_FEE',
        label: 'Commission'
    },
    CURRENCY_EXCHANGE_FEE: {
        value: 'CURRENCY_EXCHANGE_FEE',
        label: 'Currency Exchange Fee'
    },
    DEPOSIT_FEE: {
        value: 'DEPOSIT_FEE',
        label: 'Deposit Fee'
    },
    FEE: {
        value: 'FEE',
        label: 'Fee'
    },
    FUEL_OIL_FEE: {
        value: 'FUEL_OIL_FEE',
        label: 'Fuel Oil Fee'
    },
    HOTEL_FEE: {
        value: 'HOTEL_FEE',
        label: 'Hotel Fee'
    },
    HOUSE_RENTAL_FEE: {
        value: 'HOUSE_RENTAL_FEE',
        label: 'House Rental Fee'
    },
    INSURANCE_FEE: {
        value: 'INSURANCE_FEE',
        label: 'Insurance Fee'
    },
    INVESTMENT_FEE: {
        value: 'INVESTMENT_FEE',
        label: 'Investment Fee'
    },
    LEASING_FEE: {
        value: 'LEASING_FEE',
        label: 'Leasing Fee'
    },
    LEGAL_FEE: {
        value: 'LEGAL_FEE',
        label: 'Legal Fee'
    },
    MANAGEMENT_FEE: {
        value: 'MANAGEMENT_FEE',
        label: 'Management fee'
    },
    MISC_FEE: {
        value: 'MISC_FEE',
        label: 'Misc Fee'
    },
    OWNERS_COST_FEE: {
        value: 'OWNERS_COST_FEE',
        label: "Owner's Cost Fee"
    },
    PERSONNEL_FEE: {
        value: 'PERSONNEL_FEE',
        label: 'Personnel Fee'
    },
    PHONE_INTERNET_FEE: {
        value: 'PHONE_INTERNET_FEE',
        label: 'Phone Internet Fee'
    },
    PROVISIONS_FEE: {
        value: 'PROVISIONS_FEE',
        label: 'Positions Fee'
    },
    R_CREW_FEE: {
        value: 'R_CREW_FEE',
        label: 'R Crew Fee'
    },
    RACE_FEE: {
        value: 'RACE_FEE',
        label: 'Race Fee'
    },
    REFURBISHMENT: {
        value: 'REFURBISHMENT',
        label: 'Refurbishment'
    },
    REPAIRS_RACE_FEE: {
        value: 'REPAIRS_RACE_FEE',
        label: "Repair's Race Fee"
    },
    SALARIES_FEE: {
        value: 'SALARIES_FEE',
        label: 'Salaries Fee'
    },
    SANCTION_FEE: {
        value: 'SANCTION_FEE',
        label: 'Sanction Fee'
    },
    SERVICE_FEE: {
        value: 'SERVICE_FEE',
        label: 'Service Fee'
    },
    SUPPLIERS_RACE_FEE: {
        value: 'SUPPLIERS_RACE_FEE',
        label: "Supplier's Race Fee"
    },
    SUPPLIES_FEE: {
        value: 'SUPPLIES_FEE',
        label: 'Supplies Fee'
    },
    TAXI_PARKING_FEE: {
        value: 'TAXI_PARKING_FEE',
        label: 'Taxi/Parking Fee'
    },
    VAT_FEE: {
        value: 'VAT_FEE',
        label: 'Vat Fee'
    },
    WITHDRAWAL_FEE: {
        value: 'WITHDRAWAL_FEE',
        label: 'Withdrawal Fee'
    },
    SHORT_SELL: {
        value: 'SHORT_SELL',
        label: 'Short Sell'
    },
    CLOSE_SHORT_SELL: {
        value: 'CLOSE_SHORT_SELL',
        label: 'Close Short Sell'
    }
};
